'use strict';
// require('es6-promise').polyfill();
// import fetch from 'isomorphic-fetch';
import 'core-js/es6/promise';
import 'whatwg-fetch';

import config from 'config';
import { normalize } from 'normalizr';
import clrSso from 'clarity-ui-sso';
import schemas from 'schemas';
import _ from 'lodash';

const getResponseData  = (json, apiUrl) => {
  return _.contains(apiUrl, 'validate') ? Object.assign({}, {user: json}) : json;
};

const getNormalizedPayload = (json, apiUrl, schema) => {
  var jsonData = _.has(json, 'data') ? json.data : getResponseData(json, apiUrl);
  var payload = normalize(jsonData, schema);
  return _.has(json, 'errors') ? Object.assign(payload, {errors: json.errors}) : payload;
};

const isUnexpectedToken = (error) => {
  if (_.contains(error.toString().toLowerCase(), 'unexpected token')) {
    return true;
  } else {
    return false;
  }
};

const dispatchError = (dispatch, error, failureType) => {
  if (isUnexpectedToken(error)) {
    clrSso.logout();
  }
  console.log('before', failureType);
  dispatch(
    Object.assign({}, {
      payload: {errors: [{message: error.toString() + '. ' + failureType}]},
      type: failureType
    })
  );
  console.log('after', failureType);
};

const dispatchFetch = async (dispatch, apiUrl, fetchType, headers, schema, graphql, successType, failureType, hasPreviousError) => {
  var token = localStorage.getItem('token');
  var fetchContent = {
      method: fetchType,
      headers: headers
  };

  if (token) {
    headers.Authorization = token;
  }
  if (fetchType === 'post') {
    _.assign(fetchContent, {body: JSON.stringify(graphql)});
  }

  return await fetch(apiUrl, fetchContent)
    .then(response => response.json())
    .then(
      json => {
        if (_.has(json, 'message') && (_.contains(json.message, 'Token is empty') || _.contains(json.message, 'Session has expired'))) {
          throw new Error('unexpected token');
        }
        console.log('before', successType);
        dispatch(
          Object.assign({}, {
            payload: getNormalizedPayload(json, apiUrl, schema),
            type: successType
          })
        );
        console.log('after', successType);
      }
    )
    .catch(
      error => {
        if (isUnexpectedToken(error) && !hasPreviousError) {
          return dispatchFetch(dispatch, apiUrl, fetchType, headers, schema, graphql, successType, failureType, true);
        } else {
          dispatchError(dispatch, error, failureType);
        }
      }
    );
};

// Helper function to fetch token from endpoint
const fetchTokenFromEndpoint = async (code) => {
  const tokenUrl = config.tokenApiTUrl + `?code=${code}`;

  try {
    const tokenResponse = await fetch(tokenUrl, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });

    if (!tokenResponse.ok) {
      console.log(`Token fetch failed: ${tokenResponse.status}`);
      throw new Error(`Token fetch failed: ${tokenResponse.status}`);
    }

    const tokenData = await tokenResponse.json();
    const token = tokenData.token;

    // Store the token
    localStorage.setItem('token', token);
    console.log('Token fetched and stored successfully');

    return token;
  } catch (error) {
    console.error('Error fetching token:', error);
    throw error;
  }
};

export default function callAPIMiddleware({ dispatch, getState }) {

  return next => action => {
    // Non standard action.
    if (!action.payload) {
      return next(action);
    }

    const {
      requestTypes,
      remote = () => false,
      shouldCallAPI = () => true,
      schema = schemas,
      graphql = {}
    } = action.payload;

    // Normal action: pass it on
    if (!remote) {
      return next(action);
    }

    // Normal action: pass it on
    if (!requestTypes) {
      return next(action);
    }

    if (
      !Array.isArray(requestTypes) ||
      requestTypes.length !== 3 ||
      !requestTypes.every(requestTypes => typeof requestTypes === 'string')
    ) {
      throw new Error('Expected an array of three string types.');
    }

    if (!shouldCallAPI(getState())) {
      return;
    }

    const [ requestType, successType, failureType ] = requestTypes;

    /*eslint no-console: 0*/
    console.log('before', requestType, action.payload);
    dispatch(Object.assign({}, {
      payload: graphql,
      type: requestType
    }));
    console.log('after', requestType);

    var headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    };

    var apiUrl = config.apiUrl;

    if (action.payload.isAuthAPI) {
      apiUrl = config.authApiUrl + action.payload.authApiName;
    }

    return new Promise(async (resolve, reject) => {
      let ticks = 0;

      const url = new URL(window.location.href);
      const code = url.searchParams.get('code');

      // ONLY fetch token if query parameter exists AND no token in storage
      if (code && !localStorage.getItem('token')) {
        console.log('Auth code found in URL, fetching token');

        try {
          // Token is now set, proceed with original request
          window.history.replaceState(null, null, window.location.pathname);

          await fetchTokenFromEndpoint(code);

        } catch (tokenError) {
          // Handle token fetch error
          dispatch({
            type: failureType,
            payload: { errors: [{ message: `Token fetch failed: ${tokenError.message}` }] }
          });
          reject(tokenError);
        }
      }

      const inter = setInterval(() => {
        ticks++;
        const token = localStorage.getItem('token');
        if (token || ticks >= 10) {
          clearInterval(inter);
          dispatchFetch(dispatch, apiUrl, action.payload.fetchType, headers, schema, graphql, successType, failureType, false).then(resolve);
        }
      }, 50);
    });
  };
}



// WEBPACK FOOTER //
// ./src/store/callAPIMiddleware.js